// Read the top-of-proof details straight from the served papers' own text:
// the court's name/street/city (Summons item "The name and address of the
// court is") and the filer — the plaintiff's attorney, or the plaintiff without
// an attorney (Summons "The name, address, and telephone number of plaintiff's
// attorney, or plaintiff without an attorney, is"; or the caption box
// "ATTORNEY OR PARTY WITHOUT ATTORNEY"). Pure text parsing — no network.
// CRA-safe: ES5 only (no destructuring / arrow-heavy syntax issues).
var PHONE = /\(?\b\d{3}\)?[\s.\-]*\d{3}[\s.\-]*\d{4}\b/;
var EMAIL = /[A-Za-z0-9._%+\-]+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,}/;
var CITYZIP = /[A-Za-z .'\-]+,?\s*(CA|California)\.?\s*\d{5}(-\d{4})?/i;
var STREET = /^\s*\d{1,6}\s+\S/;

function clean(l) { return String(l || "").replace(/\s+/g, " ").trim(); }
function isSpanish(l) { return /^\(?\s*(el nombre|la direcci|el n[uú]mero|del abogado|de la corte)/i.test(l) || /\b(es\)|corte es|abogado)\b/i.test(l); }
function stopLine(l) { return /^(DATE|Fecha|Clerk|NOTICE|AVISO|CASE NUMBER|N[uú]mero del Caso|\[SEAL\]|Deputy|by Clerk)/i.test(l) || /^\d\.\s/.test(l); }

function linesAfter(lines, labelRe, max) {
  var i, j, out = [];
  for (i = 0; i < lines.length; i += 1) {
    if (labelRe.test(lines[i])) {
      // Text on the same line after the label (e.g. "...is: 247 W. 3rd St").
      var rest = clean(lines[i].replace(labelRe, "").replace(/^[^:]*:\s*/, ""));
      if (rest && !isSpanish(rest)) out.push(rest);
      for (j = i + 1; j < lines.length && out.length < (max || 6); j += 1) {
        var l = clean(lines[j]);
        if (!l) continue;
        if (isSpanish(l)) continue;
        if (stopLine(l)) break;
        out.push(l.replace(/^\(?[^)]*\):\s*/, ""));
      }
      return out.filter(function (x) { return x; });
    }
  }
  return [];
}

function parseCourt(block) {
  var r = { courtName: "", courtStreet: "", courtCityZip: "", courtBranch: "" };
  var parts = [];
  block.forEach(function (l) { l.split(/\s*;\s*/).forEach(function (p) { if (p) parts.push(p); }); });
  // A single line "San Bernardino Superior Court, 247 W. 3rd St., San Bernardino, CA 92415"
  if (parts.length === 1 && /,/.test(parts[0])) parts = parts[0].split(/,\s*(?=\d|[A-Za-z .]+,?\s*CA\b)/);
  var k;
  for (k = 0; k < parts.length; k += 1) {
    var p = clean(parts[k]);
    if (!r.courtStreet && STREET.test(p)) {
      // "7339 S. Painter Avenue, Whittier, CA 90602" → street + city/ZIP.
      var cz = p.match(/,\s*([A-Za-z .'\-]+,?\s*(CA|California)\.?\s*\d{5}(-\d{4})?)\s*$/i);
      if (cz) { r.courtStreet = clean(p.slice(0, cz.index)); r.courtCityZip = clean(cz[1]); }
      else r.courtStreet = p.replace(/,\s*$/, "");
      continue;
    }
    if (r.courtStreet && !r.courtBranch && /justice center|courthouse|hall of justice|court\s*house|branch/i.test(p)) { r.courtBranch = p; continue; }
    if (r.courtStreet && !r.courtCityZip && CITYZIP.test(p)) { r.courtCityZip = (p.match(CITYZIP) || [""])[0].trim(); continue; }
    if (!r.courtStreet) {
      if (!r.courtName) r.courtName = p;
      else if (!/superior court of california/i.test(p)) r.courtBranch = p;
    }
  }
  // "San Bernardino Justice Center" style names are the branch.
  if (!r.courtBranch && /justice center|courthouse|hall of justice|court\s*house/i.test(r.courtName)) r.courtBranch = r.courtName;
  return r;
}

function parseFiler(block) {
  var r = { filerName: "", filerAddress: "", filerPhone: "", filerEmail: "" };
  var text = block.join("\n");
  var ph = text.match(PHONE); if (ph) r.filerPhone = clean(ph[0]);
  var em = text.match(EMAIL); if (em) r.filerEmail = em[0];
  var addr = [];
  block.forEach(function (l, idx) {
    var x = clean(l.replace(EMAIL, "").replace(PHONE, "").replace(/\b(TELEPHONE|FAX)\s*NO\.?\s*:?/gi, "").replace(/\b(Tel(ephone)?|Phone|Fax|E-?mail)\.?:?/gi, "").replace(/[,;]\s*$/, ""));
    if (!x) return;
    if (idx === 0 && !r.filerName) {
      // "Name, 123 Street, City, CA 92xxx" on one line → split at the first number.
      var m = x.match(/^([^,\d]+?)(?:,\s*|\s+)(\d.*)$/);
      if (m) { r.filerName = clean(m[1]); addr.push(clean(m[2])); return; }
      r.filerName = x.replace(/,\s*$/, ""); return;
    }
    if (/state bar|sbn/i.test(x)) return;
    addr.push(x);
  });
  r.filerAddress = addr.join(", ").replace(/,\s*,/g, ",").trim();
  return r;
}

function parseCaseHeader(rawText) {
  var lines = String(rawText || "").split(/\r?\n/).map(clean).filter(function (l) { return l; });
  // Civil Summons (SUM-100): "...of the court is", "plaintiff's attorney ... is".
  // Family Law Summons (FL-110): "...of the court are", "petitioner's attorney ... are".
  var courtBlock = linesAfter(lines, /name and address of the court (is|are)/i, 5);
  var filerBlock = linesAfter(lines, /telephone number of (the )?(plaintiff|petitioner)['’]?s attorney,? or (the )?(plaintiff|petitioner) without an attorney,? (is|are)/i, 5);
  var cap = parseCaption(lines);
  // No Summons wording: an unlabelled caption box (older forms) is read as lines.
  if (!filerBlock.length && !cap.filerName && !cap.filerAddress) {
    filerBlock = linesAfter(lines, /attorney or party without attorney|party without attorney or attorney/i, 5);
    var cut = filerBlock.findIndex(function (l) { return /superior court of california|for court use/i.test(l); });
    if (cut >= 0) filerBlock = filerBlock.slice(0, cut);
  }
  var out = { courtName: "", courtStreet: "", courtCityZip: "", courtBranch: "", filerName: "", filerAddress: "", filerPhone: "", filerEmail: "" };
  if (courtBlock.length) { var c = parseCourt(courtBlock); Object.keys(c).forEach(function (k2) { out[k2] = c[k2]; }); }
  if (filerBlock.length) { var f = parseFiler(filerBlock); Object.keys(f).forEach(function (k3) { out[k3] = f[k3]; }); }
  // The box at the top of every Judicial Council form (petition, summons,
  // request for order…) fills whatever the Summons wording didn't.
  Object.keys(cap).forEach(function (k4) { if (!out[k4] && cap[k4]) out[k4] = cap[k4]; });
  return out;
}

// CAPTION BOX of a Judicial Council form, as read from a scan:
//   ATTORNEY OR PARTY WITHOUT ATTORNEY (or PARTY WITHOUT ATTORNEY OR ATTORNEY)
//     NAME: …  FIRM NAME: …  STREET ADDRESS: …  CITY: … STATE: … ZIP CODE: …  TELEPHONE NO.: …
//   SUPERIOR COURT OF CALIFORNIA, COUNTY OF …
//     STREET ADDRESS: …  MAILING ADDRESS: …  CITY AND ZIP CODE: …  BRANCH NAME: …
// A label's value is on the same line, or on the next line when the scan put
// it there. Labels with nothing filled in are skipped.
var CAP_LABEL = /^(NAME|FIRM NAME|STREET ADDRESS|MAILING ADDRESS|CITY AND ZIP CODE|CITY|STATE|ZIP CODE|TELEPHONE NO\.?|FAX NO\.?|E-?MAIL ADDRESS|ATTORNEY FOR( \(name\))?|STATE BAR NO\.?|BRANCH NAME)\s*:?/i;
function capValue(lines, i, label) {
  var rest = clean(lines[i].replace(label, "").replace(/^[:\s]+/, ""));
  // Another label on the same line ("CITY: Corona STATE: CA ZIP CODE: 92878").
  if (rest) return rest;
  var nxt = lines[i + 1] ? clean(lines[i + 1]) : "";
  if (nxt && !CAP_LABEL.test(nxt) && !/superior court|for court use|case number/i.test(nxt)) return nxt;
  return "";
}
function parseCaption(lines) {
  var out = { courtStreet: "", courtCityZip: "", courtBranch: "", filerName: "", filerAddress: "", filerPhone: "", filerEmail: "" };
  var courtAt = -1, filerAt = -1, i;
  for (i = 0; i < lines.length; i += 1) {
    if (filerAt < 0 && /attorney or party without attorney|party without attorney or attorney/i.test(lines[i])) filerAt = i;
    if (courtAt < 0 && /superior court of california/i.test(lines[i]) && (filerAt < 0 || i > filerAt)) { courtAt = i; break; }
  }
  // Court box: the labelled lines right under "SUPERIOR COURT OF CALIFORNIA".
  if (courtAt >= 0) {
    for (i = courtAt + 1; i < Math.min(lines.length, courtAt + 12); i += 1) {
      var l = lines[i];
      if (/^(PETITIONER|PLAINTIFF|RESPONDENT|DEFENDANT)\b/i.test(l)) break;
      if (!out.courtStreet && /^STREET ADDRESS\s*:?/i.test(l)) out.courtStreet = capValue(lines, i, /^STREET ADDRESS\s*:?/i);
      else if (!out.courtCityZip && /^CITY AND ZIP CODE\s*:?/i.test(l)) out.courtCityZip = capValue(lines, i, /^CITY AND ZIP CODE\s*:?/i);
      else if (!out.courtBranch && /^BRANCH NAME\s*:?/i.test(l)) out.courtBranch = capValue(lines, i, /^BRANCH NAME\s*:?/i);
    }
    if (out.courtStreet && !STREET.test(out.courtStreet)) out.courtStreet = "";
    // "Whittier 90602" → "Whittier, CA 90602"
    var cz = out.courtCityZip.match(/^([A-Za-z .'\-]+?),?\s+(\d{5}(-\d{4})?)$/);
    if (cz) out.courtCityZip = clean(cz[1]) + ", CA " + cz[2];
  }
  // Filer box: labelled fields between the filer label and the court line.
  if (filerAt >= 0) {
    var end = courtAt > filerAt ? courtAt : Math.min(lines.length, filerAt + 12);
    var street = "", city = "", state = "", zip = "";
    for (i = filerAt + 1; i < end; i += 1) {
      var t = lines[i];
      if (!out.filerPhone && /TELEPHONE/i.test(t)) { var ph = (t.match(PHONE) || capValue(lines, i, /^TELEPHONE NO\.?\s*:?/i).match(PHONE)); if (ph) out.filerPhone = clean(ph[0]); }
      var em = t.match(EMAIL); if (!out.filerEmail && em) out.filerEmail = em[0];
      if (!out.filerName && /^NAME\s*:?/i.test(t)) out.filerName = capValue(lines, i, /^NAME\s*:?/i);
      else if (!street && /^STREET ADDRESS\s*:?/i.test(t)) street = capValue(lines, i, /^STREET ADDRESS\s*:?/i);
      else if (/^CITY\s*:?/i.test(t) && !/CITY AND ZIP/i.test(t)) {
        var m = t.match(/^CITY\s*:?\s*(.*?)\s*(STATE\s*:?\s*([A-Z]{2}))?\s*(ZIP CODE\s*:?\s*(\d{5}(-\d{4})?))?\s*$/i);
        city = clean((m && m[1]) || capValue(lines, i, /^CITY\s*:?/i)); if (m && m[3]) state = m[3]; if (m && m[5]) zip = m[5];
      } else if (!state && /^STATE\s*:?/i.test(t)) { state = capValue(lines, i, /^STATE\s*:?/i).split(/\s+/)[0]; var z = t.match(/\d{5}(-\d{4})?/); if (z) zip = z[0]; }
      else if (!zip && /^ZIP CODE\s*:?/i.test(t)) { var z2 = (capValue(lines, i, /^ZIP CODE\s*:?/i).match(/\d{5}(-\d{4})?/) || [""])[0]; zip = z2; }
    }
    if (street && STREET.test(street)) {
      var tail = clean([city, [state || (city ? "CA" : ""), zip].filter(Boolean).join(" ")].filter(Boolean).join(", "));
      out.filerAddress = clean([street, tail].filter(Boolean).join(", "));
    }
  }
  return out;
}

// POSITIONAL read of a Summons page (pdf.js text items {str, x, y}). Court
// e-filing tools stamp the filled values as text placed under each label, not
// in reading order, so the values are found by where they sit: between "The
// name and address of the court is" and the filer label, and between the filer
// label and "DATE:". The case-number column on the right is ignored.
function isStatic(str) {
  return /address of the court (is|are)|telephone number of (the )?(plaintiff|petitioner)|^\(?el nombre|direcci[oó]n|^\(?n[uú]mero del caso|^case number|^\(?fecha|^date:?$|clerk, by|^\(?secretario|^, deputy|^\(?adjunto/i.test(clean(str));
}
function parseSummonsItems(items) {
  var list = (items || []).filter(function (i) { return i && clean(i.str); });
  var court = null, filer = null, date = null, k;
  for (k = 0; k < list.length; k += 1) {
    var t = clean(list[k].str);
    if (!court && /address of the court (is|are)/i.test(t)) court = list[k];
    else if (!filer && /telephone number of (the )?(plaintiff|petitioner)/i.test(t)) filer = list[k];
    else if (filer && !date && /^DATE:?$/i.test(t) && list[k].y < filer.y) date = list[k];
  }
  var out = { courtName: "", courtStreet: "", courtCityZip: "", courtBranch: "", filerName: "", filerAddress: "", filerPhone: "", filerEmail: "" };
  var between = function (top, bottom, maxX) {
    return list.filter(function (i) { return i.y < top - 2 && i.y > bottom + 2 && i.x < maxX && !isStatic(i.str); })
      .sort(function (a, b) { return (b.y - a.y) || (a.x - b.x); }).map(function (i) { return clean(i.str); });
  };
  if (court) {
    var cl = between(court.y + 3, filer ? filer.y : court.y - 60, 350);
    cl.forEach(function (l) {
      if (/superior court|justice court|district court/i.test(l) && !STREET.test(l)) { if (!out.courtName) out.courtName = l; return; }
      if (STREET.test(l) && !out.courtStreet) {
        var dash = l.split(/\s+[-–]\s+/);
        if (dash.length > 1) out.courtBranch = clean(dash.slice(1).join(" - "));
        var main = dash[0];
        var ci = main.indexOf(",");
        out.courtStreet = ci > 0 ? clean(main.slice(0, ci)) : clean(main);
        var cz = (main.slice(ci + 1).match(CITYZIP) || [""])[0];
        out.courtCityZip = clean(cz);
        return;
      }
      if (out.courtStreet && !out.courtCityZip && CITYZIP.test(l)) out.courtCityZip = clean((l.match(CITYZIP) || [""])[0]);
    });
  }
  if (filer) {
    var fl = between(filer.y, date ? date.y : filer.y - 35, 520);
    var parts = [];
    fl.forEach(function (l) { l.split(/\s*\|\s*/).forEach(function (p2) { if (clean(p2)) parts.push(clean(p2)); }); });
    var addr = [];
    parts.forEach(function (p3, idx) {
      var em = p3.match(EMAIL); if (em && !out.filerEmail) { out.filerEmail = em[0]; return; }
      var ph = p3.match(PHONE); if (ph && !out.filerPhone && p3.replace(PHONE, "").replace(/[\s()\-.]/g, "").length < 4) { out.filerPhone = clean(ph[0]); return; }
      if (idx === 0) { out.filerName = clean(p3.split(",")[0]); return; }
      addr.push(p3);
    });
    out.filerAddress = addr.join(", ");
  }
  return out;
}

// Printed Summons wording that sits near the filer box (clerk's date line,
// the POS-010 notice) is never part of the filer's name or address. A filer
// "address" with no street number and no city/ZIP is not an address at all.
var JUNK = /deputy|adjunto|clerk|secretario|for proof of service|para prueba|proof of service of summons|form POS-010|entrega de esta|^\(?\d{1,2}\/\d{1,2}\/\d{2,4}\)?$|^date:?$|^fecha/i;
function scrub(out) {
  if (!out) return out;
  if (JUNK.test(out.filerName || "")) out.filerName = "";
  var parts = String(out.filerAddress || "").split(/,\s*/).map(clean).filter(function (p) { return p && !JUNK.test(p); });
  var addr = parts.join(", ");
  out.filerAddress = (STREET.test(addr) || /\b\d{1,6}\s+\S/.test(addr)) && /\b[A-Za-z]{2,}\.?,?\s+\d{5}(-\d{4})?\b/.test(addr) ? addr : "";
  if (JUNK.test(out.courtStreet || "")) out.courtStreet = "";
  // A phone number inside the court street means the reader mixed up the
  // filer's lines with the court's — don't save that as the court.
  if (PHONE.test(out.courtStreet || "") || /\b\d{3}\s?\d{7}\b/.test(out.courtStreet || "")) { out.courtStreet = ""; out.courtCityZip = ""; }
  // A "name" that is really a street address is not a name.
  if (/^\s*\d{2,6}\s+\S/.test(out.filerName || "")) out.filerName = "";
  return out;
}
var parseCaseHeaderRaw = parseCaseHeader, parseSummonsItemsRaw = parseSummonsItems;
module.exports = {
  parseCaseHeader: function (t) { return scrub(parseCaseHeaderRaw(t)); },
  parseSummonsItems: function (i) { return scrub(parseSummonsItemsRaw(i)); },
  parseCaption: parseCaption, scrub: scrub,
};
